/** Path of the identity providers list page. */
export const IDENTITY_PROVIDERS_PATH =
  "/settings/access-control/identity-providers";

/**
 * Tooltip copy for the provider management actions, which are disabled without
 * system edit permission.
 */
export const MANAGE_PROVIDERS_PERMISSION_MESSAGE =
  "You need system edit permission to add an identity provider";

/**
 * Path of a single provider's details page. Providers are addressed by their
 * Cognito provider name, which is unique and immutable but caller-supplied, so
 * it is encoded rather than interpolated raw.
 */
export function identityProviderPath(name: string) {
  return `${IDENTITY_PROVIDERS_PATH}/${encodeURIComponent(name)}`;
}

/**
 * Tooltip copy for the details page's edit action, which is not implemented
 * yet.
 */
export const EDIT_PROVIDER_UNAVAILABLE_MESSAGE =
  "Editing an identity provider is not available yet";
